import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractPopupMediator from "../../../core/ui/AbstractPopupMediator";
import GameClock from "../../../../../lib/html5-software-library/src/ranj/eng/story/framework/clock/GameClock";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import GameEvent from "../../../core/application/GameEvent";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";

export default class ExitPopupMediator extends AbstractPopupMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack
     * @param {GameClock} gameClock
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, gameClock) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._gameClock = gameClock;
    }

    initialize() {
        super.initialize();
        this._target.titleTextField.text = this._languagePack.getText(`exit.title`);
        this._target.descriptionTextField.text = this._languagePack.getText(`exit.description`);
        this.createButton(this._target.resumeButton, this.close.bind(this), this._languagePack.getText(`exit.resumeButtonLabel`));
        this._closeBound = this.close.bind(this);
        this._target.bg.addEventListener('click', this._closeBound);
        this.preventClickThrough();
        this.dispatch(GameEvent.PAUSE_GAME);
    }

    destroy() {
        this._target.bg.removeEventListener('click', this._closeBound);
        super.destroy();
    }

    close() {
        this.dispatch(GameEvent.RESUME_GAME);
        this.closePopup(this._target, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 150)
        });

        let onClose = this._target.onClose;
        if (onClose != null) {
            onClose();
        }
    }
}